angular.module( 'acme.view.application.membership.offerings.create.lifecycle.modals.details', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.offerings.create.lifecycle.modals.details.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipOfferingsCreateLifecycleModalsDetails = {
        name: 'application.membership.offerings.create.lifecycle.modals.details',
        url: '/membership/offerings/create/lifecycle/modals/details',
        views: {
          "main": {
            controller: 'MembershipOfferingsCreateLifecycleModalsDetailsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/offerings/create/lifecycle/modals/details/details.tpl.html'
          }
        },
        data: {
          pageTitle: '      ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipOfferingsCreateLifecycleModalsDetails);
});
